import React, { useEffect, useState } from "react";
import {
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@mui/material";
import { ApplicationHistoryData } from "./Data/ConstableData";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../Components/MaterialTableStyle/MaterialTableStyle";
import CustomCheckBox from "../../Components/CheckBox/CustomCheckBox";
import CerificateModal from "./Modal/CerificateModal";
import { GetPublicURL } from "../../Helper/api";

const ApplicationDetails1 = ({
  isShowAll,
  CandidateDetail,
  kindetails,
  PhysicalList,
  physicalTestLocations,
  MedicalTestLocations,
  ComputerTestLocations,
  EducationQualifications,
  refereeinformation,
  furtherinformation,
  setAffirmationcheck,
  Affirmationcheck,
  isAffirmation,
}) => {
  const [imageUrl, setImageUrl] = useState("");
  const [certificateImageModal, setCertificateImageModal] = useState(false);
  const [certificateName, setCertificateName] = useState("");
  const [fileExtentions, setfileExtentions] = useState("");

  const [dropDownData, setDropDownData] = useState({
    ApplicationBasic: false,
    NextofKinDetails: false,
    PhysicalFitnessRequirements: false,
    EducationalQualification: false,
  });
  // const [physicalFitnessDetails, setPhysicalFitnessDetails] = useState({
  //   height: "",
  //   weight: "",
  //   ChestLength: "",
  //   ExpandChestLength: "",
  //   dentalcondition: "",
  //   flatfeet: "",
  //   squintingeyes: "",
  //   bowlegs: "",
  // });
  const HandleDropDown = (name) => {
    setDropDownData((prevValue) => ({
      ...prevValue,
      [name]: !prevValue[name],
    }));
  };
  const OpenCerticateImage = async (row) => {
    setCertificateName(row.qualificationLevel);
    setfileExtentions(String(row.certificateAttachmentURL).split(".").pop());
    let Url = await GetPublicURL(row.certificateAttachmentURL);

    setImageUrl(Url);
    setCertificateImageModal(true);
  };
  const CloseCerticateImage = () => {
    setCertificateImageModal(false);
  };
  // useEffect(() => {
  //   if (PhysicalList?.length > 0) {
  //     let datas = {
  //       height: "",
  //       weight: "",
  //       ChestLength: "",
  //       ExpandChestLength: "",
  //       dentalcondition: "",
  //       flatfeet: "",
  //       squintingeyes: "",
  //       bowlegs: "",
  //     };
  //     PhysicalList?.forEach((item) => {
  //       if (item.name == "Height (In Meters)" && item.value) {
  //         datas.height = item.value;
  //       }
  //       if (item.name == "Weight (In Kg)" && item.value) {
  //         datas.weight = item.value;
  //       }
  //       if ( item.name == "Chest Length (Unexpanded - in inches)" && item.value  ) {
  //         datas.ChestLength = item.value;
  //       }
  //       if (item.name == "Chest Length (Expanded - in inches)" && item.value) {
  //         datas.ExpandChestLength = item.value;
  //       }
  //       if (
  //         item.name ==
  //           "Select your dental condition (e.g., Healthy, Cavities)" &&
  //         item.value
  //       ) {
  //         datas.dentalcondition = item.value;
  //       }
  //       if (item.name == "Do you have flat feet?" && item.value) {
  //         datas.flatfeet = item.value;
  //       }
  //       if (item.name == "Do you have squinting eyes?" && item.value) {
  //         datas.squintingeyes = item.value;
  //       }
  //       if (item.name == "Do you have bow legs?" && item.value) {
  //         datas.bowlegs = item.value;
  //       }
  //     });
  //     if(datas.height!="" && datas.weight!="" && datas.ChestLength!=""){
  //       setPhysicalFitnessDetails(datas)
  //     }
  //   }
  //   console.log("Physical List:", PhysicalList);
  // }, [PhysicalList]);
  const physicalFitnessDetails = React.useMemo(() => {
    const datas = {
      height: "",
      weight: "",
      ChestLength: "",
      ExpandChestLength: "",
      dentalcondition: "",
      flatfeet: "",
      squintingeyes: "",
      bowlegs: "",
    };

    if (!PhysicalList) return datas;

    PhysicalList.forEach((item) => {
      switch (item.name) {
      case "Height (In Meters)":
        datas.height = item.value || "";
        break;
      case "Weight (In Kg)":
        datas.weight = item.value || "";
        break;
      case "Chest Length (Unexpanded - in inches)":
        datas.ChestLength = item.value || "";
        break;
      case "Chest Length (Expanded - in inches)":
        datas.ExpandChestLength = item.value || "";
        break;
      case "Select your dental condition (e.g., Healthy, Cavities)":
        datas.dentalcondition = item.value || "";
        break;
      case "Do you have flat feet?":
        datas.flatfeet = item.value || "";
        break;
      case "Do you have squinting eyes?":
        datas.squintingeyes = item.value || "";
        break;
      case "Do you have bow legs?":
        datas.bowlegs = item.value || "";
        break;
      }
    });
    console.log("Physical List:", PhysicalList);
    console.log("Physical datas:", datas);
    return datas;
  }, [PhysicalList]);
  useEffect(() => {
    console.log("STATE UPDATED:", physicalFitnessDetails);
    console.log("RENDER VALUE:", physicalFitnessDetails.height);
  }, [physicalFitnessDetails]);

  useEffect(() => {
    console.log("COMPONENT MOUNTED");
    return () => console.log("COMPONENT UNMOUNTED");
  }, []);
  return (
    <Grid
      container
      item
      lg={12}
      sm={12}
      md={12}
      xs={12}
      bgcolor={
        localStorage.getItem("@userType") == "superadmin" ||
        localStorage.getItem("@userType") == "recruitadmin" ||
        localStorage.getItem("@userType") == "fieldagentsupervisor" ||
        isShowAll
          ? "#FFFFFF"
          : 0
      }
      borderRadius={"6px"}
      flexDirection={"column"}
      alignItems={"flex-start"}
      className="p-3"
    >
      {(localStorage.getItem("@userType") == "superadmin" ||
        localStorage.getItem("@userType") == "recruitadmin" ||
        localStorage.getItem("@userType") == "fieldagentsupervisor" ||
        isShowAll) && (
        <Grid
          container
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          flexDirection={"column"}
          alignItems={"flex-start"}
        >
          <Grid
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            container
            justifyContent={"space-between"}
          >
            <h4 className="poppinsSemiBold Text-Prime-Black text-left">
              Applicant Basic Details
            </h4>
            <IconButton
              className="ButtonFoucusNone"
              onClick={() => HandleDropDown("ApplicationBasic")}
            >
              {dropDownData?.ApplicationBasic ? (
                <IoIosArrowDropup className="text-black" size={"24px"} />
              ) : (
                <IoIosArrowDropdown className="text-black " size={"24px"} />
              )}
            </IconButton>
          </Grid>
          <Divider
            className="mt-1 w-100"
            sx={{ border: "1px solid #a7aba96e" }}
          />
          {dropDownData?.ApplicationBasic && (
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              className="p-2"
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid
                item
                lg={5.9}
                sm={5.9}
                md={5.9}
                xs={5.9}
                container
                className="p-2"
                alignItems={"center"}
              >
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Title
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.Title}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Last Name
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.LastName}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Gender
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.Gender}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Marital Status
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.MaritalStatus == "Yes"
                        ? "married"
                        : "Single"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Local Government Area
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.LocalGovernmentArea}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Other Phone Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.OtherPhoneNumber
                        ? "+234 " + CandidateDetail.OtherPhoneNumber
                        : "---"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Religion
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.Religion}
                    </p>
                  </Grid>
                </Grid>

                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Other Languages Spoken
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.OtherLanguagesSpoken
                        ? CandidateDetail?.OtherLanguagesSpoken
                        : "---"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Permanent Home Address
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.PermanentHomeAddress}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                lg={5.9}
                sm={5.9}
                md={5.9}
                xs={5.9}
                container
                className="p-2"
                alignItems={"center"}
              >
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      First Name
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.Surname}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Other Name
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                      {CandidateDetail?.OtherName}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Date of Birth
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left text-capitalize ">
                      {CandidateDetail?.DateofBirth}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left text-capitalize">
                      State of Origin
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.StateofOrigin}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left ">
                      Main Phone Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.MainPhoneNumber
                        ? "+234 " + CandidateDetail.MainPhoneNumber
                        : "----"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Email
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.Email}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Languages Spoken
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.LanguagesSpoken}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Hobbies
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.Hobbies ? CandidateDetail.Hobbies : ""}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Present Residential Address
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {CandidateDetail?.PresentResidentialAddress}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      )}
      {(localStorage.getItem("@userType") == "superadmin" ||
        localStorage.getItem("@userType") == "recruitadmin" ||
        isShowAll) && (
        <Grid
          container
          item
          lg={12}
          sm={12}
          md={12}
          xs={12}
          flexDirection={"column"}
          alignItems={"flex-start"}
        >
          <Grid
            container
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            flexDirection={"column"}
            alignItems={"flex-start"}
            className="pt-3"
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <h4 className="poppinsSemiBold Text-Prime-Black text-left">
                Next of Kin Details
              </h4>
              <IconButton
                className="ButtonFoucusNone"
                onClick={() => HandleDropDown("NextofKinDetails")}
              >
                {dropDownData?.NextofKinDetails ? (
                  <IoIosArrowDropup className="text-black" size={"24px"} />
                ) : (
                  <IoIosArrowDropdown className="text-black " size={"24px"} />
                )}
              </IconButton>
            </Grid>
            <Divider
              className="mt-1 w-100"
              sx={{ border: "1px solid #a7aba96e" }}
            />
            {dropDownData?.NextofKinDetails && (
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="p-2"
                alignItems={"flex-start"}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
              >
                {kindetails?.map((item, i) => {
                  return (
                    <Grid
                      item
                      lg={5.9}
                      sm={5.9}
                      md={5.9}
                      xs={5.9}
                      key={i}
                      container
                      className="p-2"
                      alignItems={"center"}
                    >
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        className="py-2"
                        justifyContent={"space-between"}
                      >
                        <Grid item lg={6} sm={6} md={6} xs={6}>
                          <p className="poppinsMedium Text-Prime-Black text-left text-capitalize">
                            {item.name}
                          </p>
                        </Grid>
                        <Grid item lg={6} sm={6} md={6} xs={6}>
                          <p className="poppinsRegular Text-Prime-Black text-left text-capitalize">
                            {item.value}
                          </p>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        style={{ borderBottom: "2px dotted black" }}
                      />
                    </Grid>
                  );
                })}
                <Divider
                  className="mt-1 w-100"
                  sx={{ border: "1px solid #a7aba96e" }}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            container
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            flexDirection={"column"}
            alignItems={"flex-start"}
            className="py-3"
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <h4 className="poppinsSemiBold Text-Prime-Black text-left">
                Preferred Location for Physical Test
              </h4>
              <IconButton
                className="ButtonFoucusNone"
                onClick={() => HandleDropDown("PhysicalTest")}
              >
                {dropDownData?.PhysicalTest ? (
                  <IoIosArrowDropup className="text-black" size={"24px"} />
                ) : (
                  <IoIosArrowDropdown className="text-black " size={"24px"} />
                )}
              </IconButton>
            </Grid>
            <Divider
              className="mt-1 w-100"
              sx={{ border: "1px solid #a7aba96e" }}
            />
            {dropDownData?.PhysicalTest && (
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="p-2"
                alignItems={"flex-start"}
                justifyContent={"space-between"}
              >
                {physicalTestLocations?.map((item, i) => {
                  return (
                    <Grid
                      item
                      lg={5.9}
                      sm={5.9}
                      md={5.9}
                      xs={5.9}
                      key={i}
                      container
                      className="p-2"
                      alignItems={"center"}
                    >
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        className="py-2"
                        flexDirection={"column"}
                      >
                        <p className="poppinsMedium Text-Prime-Black text-left">
                          Preferred Location - {i + 1}
                        </p>
                        <p className="poppinsRegular Text-Prime-Black text-left pt-2">
                          {item.value}
                        </p>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        style={{ borderBottom: "2px dotted black" }}
                      />
                    </Grid>
                  );
                })}
                <Divider
                  className="mt-1 w-100"
                  sx={{ border: "1px solid #a7aba96e" }}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            container
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            flexDirection={"column"}
            alignItems={"flex-start"}
            className="py-3"
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                justifyContent={"space-between"}
              >
                <h4 className="poppinsSemiBold Text-Prime-Black text-left">
                  Preferred Location for Medical Screening Test
                </h4>
                <IconButton
                  className="ButtonFoucusNone"
                  onClick={() => HandleDropDown("MedicalTest")}
                >
                  {dropDownData?.MedicalTest ? (
                    <IoIosArrowDropup className="text-black" size={"24px"} />
                  ) : (
                    <IoIosArrowDropdown className="text-black " size={"24px"} />
                  )}
                </IconButton>
              </Grid>
              <Divider
                className="mt-1 w-100"
                sx={{ border: "1px solid #a7aba96e" }}
              />
            </Grid>
            {dropDownData?.MedicalTest && (
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="p-2"
                alignItems={"flex-start"}
                justifyContent={"space-between"}
              >
                {MedicalTestLocations?.map((item, i) => {
                  return (
                    <Grid
                      item
                      lg={5.9}
                      sm={5.9}
                      md={5.9}
                      xs={5.9}
                      key={i}
                      container
                      className="p-2"
                      alignItems={"center"}
                    >
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        className="py-2"
                        flexDirection={"column"}
                      >
                        <p className="poppinsMedium Text-Prime-Black text-left">
                          Preferred Location - {i + 1}
                        </p>
                        <p className="poppinsRegular Text-Prime-Black text-left pt-2">
                          {item.value}
                        </p>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        style={{ borderBottom: "2px dotted black" }}
                      />
                    </Grid>
                  );
                })}
                <Divider
                  className="mt-1 w-100"
                  sx={{ border: "1px solid #a7aba96e" }}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            container
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            flexDirection={"column"}
            alignItems={"flex-start"}
            className="py-3"
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                justifyContent={"space-between"}
              >
                <h4 className="poppinsSemiBold Text-Prime-Black text-left">
                  Preferred Location for Computer Based Test
                </h4>
                <IconButton
                  className="ButtonFoucusNone"
                  onClick={() => HandleDropDown("ComputerTest")}
                >
                  {dropDownData?.ComputerTest ? (
                    <IoIosArrowDropup className="text-black" size={"24px"} />
                  ) : (
                    <IoIosArrowDropdown className="text-black " size={"24px"} />
                  )}
                </IconButton>
              </Grid>
              <Divider
                className="mt-1 w-100"
                sx={{ border: "1px solid #a7aba96e" }}
              />
            </Grid>
            {dropDownData?.ComputerTest && (
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="p-2"
                alignItems={"flex-start"}
                justifyContent={"space-between"}
              >
                {ComputerTestLocations?.map((item, i) => {
                  return (
                    <Grid
                      item
                      lg={5.9}
                      sm={5.9}
                      md={5.9}
                      xs={5.9}
                      key={i}
                      container
                      className="p-2"
                      alignItems={"center"}
                    >
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        className="py-2"
                        flexDirection={"column"}
                      >
                        <p className="poppinsMedium Text-Prime-Black text-left">
                          Preferred Location - {i + 1}
                        </p>
                        <p className="poppinsRegular Text-Prime-Black text-left pt-2">
                          {item.value}
                        </p>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        style={{ borderBottom: "2px dotted black" }}
                      />
                    </Grid>
                  );
                })}
                <Divider
                  className="mt-1 w-100"
                  sx={{ border: "1px solid #a7aba96e" }}
                />
              </Grid>
            )}
          </Grid>

          <Grid
            container
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            flexDirection={"column"}
            alignItems={"flex-start"}
            className="pt-3"
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <h4 className="poppinsSemiBold Text-Prime-Black text-left">
                Physical Fitness Requirements
              </h4>
              <IconButton
                className="ButtonFoucusNone"
                onClick={() => HandleDropDown("PhysicalFitnessRequirements")}
              >
                {dropDownData?.PhysicalFitnessRequirements ? (
                  <IoIosArrowDropup className="text-black" size={"24px"} />
                ) : (
                  <IoIosArrowDropdown className="text-black " size={"24px"} />
                )}
              </IconButton>
            </Grid>

            <Divider
              className="mt-1 w-100"
              sx={{ border: "1px solid #a7aba96e" }}
            />
            {dropDownData?.PhysicalFitnessRequirements && (
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="p-2"
                alignItems={"flex-start"}
              >
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="p-2"
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Grid item lg={4} sm={3} md={3} xs={3}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Height (In Meters)
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left py-2">
                      {physicalFitnessDetails.height
                        ? physicalFitnessDetails?.height
                        : "--"}
                      {/* {physicalFitnessDetails.height
                        ? physicalFitnessDetails?.height
                        : "--"} */}
                    </p>
                  </Grid>
                  <Grid item lg={3} sm={3} md={3} xs={3}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Weight (In Kg)
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left py-2">
                      {physicalFitnessDetails?.weight
                        ? physicalFitnessDetails?.weight
                        : "--"}
                    </p>
                  </Grid>
                  <Grid item lg={5} sm={5} md={5} xs={5}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Chest Length (Unexpanded - in inches)
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left py-2">
                      {physicalFitnessDetails?.ChestLength
                        ? physicalFitnessDetails?.ChestLength
                        : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="p-2"
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Grid item lg={4} sm={3} md={3} xs={3}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Chest Length (Expanded - in inches)
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left py-2">
                      {physicalFitnessDetails?.ExpandChestLength
                        ? physicalFitnessDetails?.ExpandChestLength
                        : "--"}
                    </p>
                  </Grid>
                  <Grid item lg={3} sm={3} md={3} xs={3}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Select your dental condition
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left py-2">
                      {physicalFitnessDetails?.dentalcondition
                        ? physicalFitnessDetails?.dentalcondition
                        : "--"}
                    </p>
                  </Grid>
                  <Grid item lg={5} sm={5} md={5} xs={5}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Do you have flat feet?
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left py-2">
                      {physicalFitnessDetails?.flatfeet
                        ? physicalFitnessDetails?.flatfeet
                        : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="p-2"
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Grid item lg={4} sm={4} md={4} xs={4}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Do you have squinting eyes?
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left py-2">
                      {physicalFitnessDetails?.squintingeyes
                        ? physicalFitnessDetails?.squintingeyes
                        : "--"}
                    </p>
                  </Grid>
                  <Grid item lg={3} sm={3} md={3} xs={3}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Do you have bow legs?
                    </p>
                    <p className="poppinsRegular Text-Prime-Black text-left py-2">
                      {physicalFitnessDetails?.bowlegs
                        ? physicalFitnessDetails?.bowlegs
                        : "--"}
                    </p>
                  </Grid>
                  <Grid item lg={5} sm={5} md={5} xs={5} />
                </Grid>
                <Divider
                  className="mt-2 w-100"
                  sx={{ border: "1px solid #a7aba96e" }}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            container
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            flexDirection={"column"}
            alignItems={"flex-start"}
            className="pt-3"
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <h4 className="poppinsSemiBold Text-Prime-Black text-left">
                Educational Qualification
              </h4>
              <IconButton
                className="ButtonFoucusNone"
                onClick={() => HandleDropDown("EducationalQualification")}
              >
                {dropDownData?.EducationalQualification ? (
                  <IoIosArrowDropup className="text-black" size={"24px"} />
                ) : (
                  <IoIosArrowDropdown className="text-black " size={"24px"} />
                )}
              </IconButton>
            </Grid>
            <Divider
              className="mt-1 w-100"
              sx={{ border: "1px solid #a7aba96e" }}
            />
            {dropDownData?.EducationalQualification && (
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="p-2"
                alignItems={"flex-start"}
              >
                {EducationQualifications?.map((item) => {
                  return (
                    <>
                      <Grid item lg={12} sm={12} md={12} xs={12} container>
                        <h4 className="poppinsMedium Text-Prime-Black text-left">
                          {item.selectQualification}
                        </h4>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        className="p-2"
                        alignItems={"flex-start"}
                        justifyContent={"space-between"}
                      >
                        <Grid item lg={4} sm={3} md={3} xs={3}>
                          <p className="poppinsMedium Text-Prime-Black text-left">
                            Level
                          </p>
                          <p className="poppinsRegular Text-Prime-Black text-left py-2">
                            {item?.selectQualification
                              ? item?.selectQualification
                              : "--"}
                          </p>
                        </Grid>
                        <Grid item lg={3} sm={3} md={3} xs={3}>
                          <p className="poppinsMedium Text-Prime-Black text-left">
                            Course Name
                          </p>
                          <p className="poppinsRegular Text-Prime-Black text-left py-2">
                            {item?.courseName ? item?.courseName : "--"}
                          </p>
                        </Grid>
                        <Grid item lg={5} sm={5} md={5} xs={5}>
                          <p className="poppinsMedium Text-Prime-Black text-left">
                            School / Institution Name
                          </p>
                          <p className="poppinsRegular Text-Prime-Black text-left py-2">
                            {item?.institutionName
                              ? item?.institutionName
                              : "--"}
                          </p>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        className="p-2"
                        alignItems={"flex-start"}
                        justifyContent={"space-between"}
                      >
                        <Grid item lg={4} sm={3} md={3} xs={3}>
                          <p className="poppinsMedium Text-Prime-Black text-left">
                            Started On
                          </p>
                          <p className="poppinsRegular Text-Prime-Black text-left py-2">
                            {item?.startedOn ? item?.startedOn : "--"}
                          </p>
                        </Grid>
                        <Grid item lg={3} sm={3} md={3} xs={3}>
                          <p className="poppinsMedium Text-Prime-Black text-left">
                            Finished On
                          </p>
                          <p className="poppinsRegular Text-Prime-Black text-left py-2">
                            {item?.finishedOn ? item?.finishedOn : "--"}
                          </p>
                        </Grid>
                        <Grid item lg={5} sm={5} md={5} xs={5}>
                          <p className="poppinsMedium Text-Prime-Black text-left">
                            Passed in How many Sittings?
                          </p>
                          <p className="poppinsRegular Text-Prime-Black text-left py-2">
                            {item?.sittings ? item?.sittings : "--"}
                          </p>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        className="p-2"
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Grid item lg={4} sm={4} md={4} xs={4}>
                          <p className="poppinsMedium Text-Prime-Black text-left">
                            Certificate Number
                          </p>
                          <p className="poppinsRegular Text-Prime-Black text-left py-2">
                            {item?.certificateNumber
                              ? item?.certificateNumber
                              : "--"}
                          </p>
                        </Grid>
                        <Grid item lg={3} sm={3} md={3} xs={3}>
                          <p className="poppinsMedium Text-Prime-Black text-left">
                            Certificate Attachment
                          </p>
                          <p
                            className={
                              ApplicationHistoryData?.length > 0
                                ? "TextUnderGreen pointer poppinsRegular text-left py-2"
                                : "poppinsRegular Text-Prime-Black text-left py-2"
                            }
                            role="presentation"
                            onClick={() => OpenCerticateImage(item)}
                          >
                            {ApplicationHistoryData?.length > 0
                              ? "View Certificate"
                              : "--"}
                          </p>
                        </Grid>
                        <Grid item lg={5} sm={5} md={5} xs={5} />
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        sm={12}
                        md={12}
                        xs={12}
                        container
                        className="py-2"
                        justifyContent={"space-between"}
                      >
                        <TableContainer className="mt-3">
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <StyledTableRow>
                                <StyledTableCell>Subject</StyledTableCell>
                                <StyledTableCell align="center">
                                  Minimum Credit Expected
                                </StyledTableCell>
                              </StyledTableRow>
                            </TableHead>

                            {item?.table?.length > 0 ? (
                              <TableBody>
                                {item?.table?.map((row, i) => (
                                  <StyledTableRow key={i}>
                                    <StyledTableCell align="left">
                                      <p className="poppinsRegular Text-Prime-Black">
                                        {row?.subject}
                                      </p>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                      <p className="text-black poppinsRegular">
                                        {row?.Credit ? row?.Credit : "--"}
                                      </p>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                              </TableBody>
                            ) : (
                              <TableBody>
                                <StyledTableCell colSpan={2} align="center">
                                  <Grid
                                    item
                                    container
                                    lg={12}
                                    flexDirection={"column"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                  >
                                    <h5 className="text-black poppinsMedium mb-3">
                                      No Mark History Available
                                    </h5>
                                  </Grid>
                                </StyledTableCell>
                              </TableBody>
                            )}
                          </Table>
                        </TableContainer>
                      </Grid>
                      <Divider
                        className="mt-2 w-100"
                        sx={{ border: "1px solid #a7aba96e" }}
                      />
                    </>
                  );
                })}
              </Grid>
            )}
          </Grid>
          <Grid
            container
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            flexDirection={"column"}
            alignItems={"flex-start"}
            className="pt-3"
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <h4 className="poppinsSemiBold Text-Prime-Black text-left">
                Referee’s Information
              </h4>
              <IconButton
                className="ButtonFoucusNone"
                onClick={() => HandleDropDown("RefereesInformation")}
              >
                {dropDownData?.RefereesInformation ? (
                  <IoIosArrowDropup className="text-black" size={"24px"} />
                ) : (
                  <IoIosArrowDropdown className="text-black " size={"24px"} />
                )}
              </IconButton>
            </Grid>
            <Divider
              className="mt-1 w-100"
              sx={{ border: "1px solid #a7aba96e" }}
            />
            {dropDownData?.RefereesInformation && (
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="p-2"
                alignItems={"flex-start"}
              >
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="p-2"
                  alignItems={"flex-start"}
                  justifyContent={"space-between"}
                >
                  {refereeinformation?.map((item, index) => {
                    return (
                      <Grid item lg={4} key={index} sm={3} md={3} xs={3}>
                        <p className="poppinsMedium Text-Prime-Black text-left">
                          {item.name}
                        </p>
                        <p className="poppinsRegular Text-Prime-Black text-left py-2">
                          {item.value ? item.value : "---"}
                        </p>
                      </Grid>
                    );
                  })}
                </Grid>
                <Divider
                  className="mt-2 w-100"
                  sx={{ border: "1px solid #a7aba96e" }}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            container
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            flexDirection={"column"}
            alignItems={"flex-start"}
            className="pt-3"
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <h4 className="poppinsSemiBold Text-Prime-Black text-left">
                Further Information
              </h4>
              <IconButton
                className="ButtonFoucusNone"
                onClick={() => HandleDropDown("FurtherInformation")}
              >
                {dropDownData?.FurtherInformation ? (
                  <IoIosArrowDropup className="text-black" size={"24px"} />
                ) : (
                  <IoIosArrowDropdown className="text-black " size={"24px"} />
                )}
              </IconButton>
            </Grid>
            <Divider
              className="mt-1 w-100"
              sx={{ border: "1px solid #a7aba96e" }}
            />
            {dropDownData?.FurtherInformation && (
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="p-2"
                alignItems={"flex-start"}
              >
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="p-2"
                  alignItems={"flex-start"}
                  justifyContent={"space-between"}
                >
                  {furtherinformation?.map((item, i) => {
                    return (
                      <>
                        <Grid item lg={5.9} sm={5.9} key={i} md={5.9} xs={5.9}>
                          <p className="poppinsMedium Text-Prime-Black text-left">
                            {item.name}
                          </p>
                          {item.name !=
                          "How many years of work experience do you have?" ? (
                              <p className="poppinsRegular Text-Prime-Black text-left py-2"> {" "} {item.value ? item.value : "No"}   </p>
                            ) : (
                              <p className="poppinsRegular Text-Prime-Black text-left py-2">  {" "}     {item.year} Years {item.month} Months{" "}  </p>
                            )}
                        </Grid>
                        {item.value == "Yes" && (
                          <Grid item lg={12} sm={12} md={12} xs={12}>
                            <p className="poppinsMedium Text-Prime-Black text-left">
                              Give Details (if Yes):
                            </p>
                            <p className="poppinsRegular Text-Prime-Black text-left py-2">
                              {item.name1Value}
                            </p>
                          </Grid>
                        )}
                      </>
                    );
                  })}
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid
            container
            item
            lg={12}
            sm={12}
            md={12}
            xs={12}
            flexDirection={"column"}
            bgcolor={"rgba(59, 130, 246, 0.04)"}
            alignItems={"flex-start"}
            className="p-3 mt-3"
          >
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              justifyContent={"space-between"}
            >
              <h4 className="poppinsSemiBold Text-Prime-Black text-left">
                Affirmation
              </h4>
            </Grid>
            <Divider
              className="mt-1 w-100"
              sx={{ border: "1px solid #a7aba96e" }}
            />
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              className="p-2"
              alignItems={"flex-start"}
            >
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                display={"flex"}
                alignItems={"center"}
                flexDirection={"row"}
              >
                {!isAffirmation ? (
                  <CustomCheckBox
                    disableColor={"transparent"}
                    checked={Affirmationcheck}
                    onChange={() => setAffirmationcheck(!Affirmationcheck)}
                  />
                ) : (
                  <CustomCheckBox disableColor={"transparent"} checked={true} />
                )}
                <p className="poppinsRegular Text-Prime-Black text-left">
                  I agree and confirm that all the information provided above is
                  accurate and truthful to the best of my knowledge.
                </p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      <CerificateModal
        certificateImageModal={certificateImageModal}
        setCertificateImageModal={setCertificateImageModal}
        CloseCerticateImage={CloseCerticateImage}
        imageUrl={imageUrl}
        fileExtentions={fileExtentions}
        certificateName={certificateName}
        isEdit={false}
      />
    </Grid>
  );
};

export default ApplicationDetails1;
